<div class="forgot-container">
  <!-- SPINNER GLOBAL -->
  @if (loading()) {
    <div class="overlay">
      <div class="spinner"></div>
    </div>
  }

  <!-- MENSAJES -->
  @if (message()) {
    <div class="message success">
      {{ message() }}
    </div>
  }

  @if (error()) {
    <div class="message error" role="alert" aria-live="assertive">
      {{ error() }}
    </div>
  }
  <!-- STEP EMAIL -->
  @if (step() === 'email') {
    <form [formGroup]="emailForm" class="card">
      <h2>Recuperar contraseña</h2>
      <input type="email" placeholder="Correo electrónico" formControlName="email" />
      <button type="button" (click)="sendEmail()" >Enviar código</button>
      <div class="text-center">
        <button (click)="gotoLogin()" class="back-login-button">Volver</button>
      </div>
    </form>
  }

  <!-- STEP CODE -->
  @if (step() === 'code') {
    <hr />
    <br>
    <div class="message info text-center">
      Se ha enviado un código a tu correo electrónico. Por favor, revisá tu bandeja de entrada.
    </div>
    <div class="text-center">
      <button (click)="openEmailApp()" class="open-email-button">Abrir correo</button>
    </div>
    <br />
    <hr />
    <br />
    <form [formGroup]="codeForm" class="card">
      <h2>Ingresá el código</h2>
      <input type="text" placeholder="Código recibido" formControlName="code" />
      <button type="button" (click)="validateCode()" [disabled]="loading()">Validar código</button>
      <div class="text-center">
        <button (click)="gotoLogin()" class="back-login-button">Volver</button>
      </div>
    </form>
  }

  <!-- STEP RESET -->
  @if (step() === 'reset') {
    <form [formGroup]="resetForm" class="card">
      <h2>Nueva contraseña</h2>
      <input type="password" placeholder="Nueva contraseña" formControlName="password" />
      <input
        type="password"
        placeholder="Confirmar contraseña"
        formControlName="password_confirmation"
      />
      <button type="button" (click)="resetPassword()" [disabled]="loading()">
        Cambiar contraseña
      </button>
      <div class="text-center">
        <button (click)="gotoLogin()" class="back-login-button">Volver</button>
      </div>
    </form>
    <!-- STEP SUCCESS -->
  }
  @if (step() === 'success') {
    <div class="card success">
      <h2>Contraseña actualizada</h2>
      <p>Ya podés iniciar sesión con tu nueva contraseña.</p>
    </div>
    <div class="text-center">
      <button (click)="gotoLogin()" class="back-login-button">Iniciar sesión</button>
    </div>
  }
</div>
